// extracted by mini-css-extract-plugin
export default {"pageLayout":"P-z","mainContent":"Q-z","activeSidebar":"R-z","columnLayout":"S-z","columnLayoutFill":"T-z","columnLayoutLast":"U-z"};